import { instructionStrings } from '@data/instruction';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: instructionStrings.blanketInsuranceList,
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 1,
};
